import { gql } from '@apollo/client';
import DEVICE_FRAGMENT from '../fragments/deviceFragment';

const CALL_CENTER_DEVICES_QUERY = gql`
  query callCenterDevices($filter: CallCenterDeviceFilterInput, $limit: Int) {
    callCenterDevices(filter: $filter, limit: $limit) {
      ...DeviceFragment
    }
  }

  ${DEVICE_FRAGMENT}
`;

export default CALL_CENTER_DEVICES_QUERY;
